import React, { useState, useRef, useEffect } from 'react';
import goIcon from '../../img/_Go.png';
import closeIcon from '../../img/pretty-close-2.png';
import yieldIcon from '../../img/_Yield.png';
import stopIcon from '../../img/_Stop.png';

const styles = {
  container: {
    fontSize: 14,
    position: 'fixed',
    top: '11%',
    left: '17.5%',
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'column',
    zIndex: '9999',
  },
  dropdown: {
    fontSize: 14,
    cursor: 'pointer',
    backgroundColor: '#F2F2F2',
    color: '#AAA',
    width: 225,
    display: 'flex',
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  arrowContainer: {
    backgroundColor: '#01b3b8',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    borderRadius: '0px 4px 4px 0px',
  },
  arrowSvg: {
    width: 18,
    height: 18,
    fill: 'white',
    transition: 'transform 0.2s ease',
  },
  arrowOpen: {
    transform: 'rotate(180deg)',
  },
  dropdownList: {
    position: 'relative',
    top: 'calc(100% + 4px)',
    left: 0,
    right: 0,
    maxHeight: 300,
    overflowY: 'auto',
    backgroundColor: '#F2F2F2',
    zIndex: 1000,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    padding: '4px 0',
    borderRadius: '4px',
  },
  dropdownItem: {
    padding: '6px 10px',
    color: '#333',
    cursor: 'pointer',
    borderBottom: '1px solid rgba(255,255,255,0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dropdownItemHover: {
    backgroundColor: '#028a90',
    color: 'white',
  },
  selectedText: {
    whiteSpace: 'nowrap',
    flexGrow: 1,
  },
  placeholderText: {
    opacity: 0.6,
  },
};

const Filters = ({ selectedFilter, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const dropdownRef = useRef(null);

  const options = ['All', 'Match', 'Close', 'Similar', 'No-Match'];

  const iconMap = {
    Match: goIcon,
    Close: closeIcon,
    Similar: yieldIcon,
    'No-Match': stopIcon,
    All: null,
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const displayText =
    selectedFilter === 'All' || !options.includes(selectedFilter)
      ? 'Match designation (All)'
      : selectedFilter;

  return (
    <div style={styles.container} title="Filter by No-Match, Similar, or Match" ref={dropdownRef}>
      <div
        style={styles.dropdown}
        onClick={() => setIsOpen(!isOpen)}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(!isOpen);
          } else if (e.key === 'Escape') {
            setIsOpen(false);
          }
        }}
        role="combobox"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span
          style={{
            ...styles.selectedText,
            ...(displayText === 'Match designation (All)' ? styles.placeholderText : {}),
          }}
        >
          {displayText}
        </span>
        <div style={styles.arrowContainer}>
          <svg
            style={{
              ...styles.arrowSvg,
              ...(isOpen ? styles.arrowOpen : {}),
            }}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M7 10l5 5 5-5z" />
          </svg>
        </div>
      </div>

      {isOpen && (
        <div style={styles.dropdownList} role="listbox" tabIndex={-1}>
          {options.map((option) => (
            <div
              key={option}
              role="option"
              aria-selected={selectedFilter === option}
              tabIndex={0}
              onClick={() => {
                onChange(option);
                setIsOpen(false);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onChange(option);
                  setIsOpen(false);
                }
              }}
              onMouseEnter={() => setHoveredItem(option)}
              onMouseLeave={() => setHoveredItem(null)}
              style={{
                ...styles.dropdownItem,
                ...(hoveredItem === option ? styles.dropdownItemHover : {}),
                fontWeight: selectedFilter === option ? 'bold' : 'normal',
              }}
            >
              <span>{option}</span>
              {iconMap[option] && (
                <img
                  src={iconMap[option]}
                  alt=""
                  style={{ width: 18, height: 18, marginLeft: 6 }}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Filters;
